module.exports = __webpack_public_path__ + "qr_code_android_faco.6c2fcc0.png";